/** @type {import('tailwindcss').Config} */

// Note: We should avoid over use of enum colours, however it is good for colours shared globally.
// Please when adding a new colour, give good justification for why it is needed globally.
export enum tailwindColors {
  // ===== STATUS COLORS =====
  // These are the colours used for the alert system throughout the app.
  // Primary status colors
  pass = '#38BF26',
  pass_hover = '#2FA31D',
  pass_bg_hover = '#F0FDF4',

  alert_dark = '#FC7315',
  alert = '#FF8A47',
  alert_hover = '#FF7A3D',
  alert_bg_hover = '#FFF4ED',

  fail = '#ED150E',
  na = '#A7A7A7',

  // ===== Brand Colors =====
  mainblue = '#274C77',
  mainblue_hover = '#1E3B5C',
  background = '#E7ECEF',

}

export default {
  content: ['./index.html', './src/**/*.{js,ts,jsx,tsx}'],
  theme: {
    extend: {
      colors: {
        ...Object.entries(tailwindColors).reduce(
          (acc, [key, value]) => {
            acc[key] = value;
            return acc;
          },
          {} as Record<string, string>,
        ),
      },
    },
  },
};
